window.addEventListener("load", (event) => {
	//
	// js pour l'ouverture du panel de gestion des cookies
	//
	const open = document.getElementsByClassName("open");
	for(let i = 0; i < open.length; i++) {
		open[i].addEventListener("click", function() {
			event.preventDefault();
			tarteaucitron.userInterface.openPanel();
		});
	}
    
    
    //
    // js pour la réécriture des emails
    //
    function deObfuscateEmail(mail) {
        mail.href = mail.href.replace(new RegExp("%7BAT%7D", 'g'), '@').replace(new RegExp("%7BDOT%7D", 'g'), '.');

        let mailSpan = mail.querySelector("span");
        mailSpan.innerText = mailSpan.innerText.replace(new RegExp("{AT}", 'g'), '@').replace(new RegExp("{DOT}", 'g'), '.');

        mail.classList.remove('opacity-0');
    }

    document.querySelectorAll('.obfuscated').forEach((mail) => {
        deObfuscateEmail(mail);
    });


    //
	// js pour transformer les liens
	//
	var links = document.querySelectorAll('[role="link"]');

	function dataToHref(link) {
		if(link.hasAttribute('data-href')) {
			link.setAttribute('href', link.getAttribute('data-href'));
			link.removeAttribute('data-href');
		}
	}

	links.forEach(function(link) {
		link.addEventListener('mouseover', function() {
			dataToHref(this);
		});

		link.addEventListener('focusin', function() {
			dataToHref(this);
		});

		link.addEventListener('click', function() {
			dataToHref(this);
		});
	});

});